import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosInstance } from "axios";
import { WholeSubscriptionStatus } from "../../utils/types/ecommerceType";
import { API_BASE_URL } from "../../utils/constants";
import React from "react";
import { parsePlanFromKeycloak } from "../../utils/isExtensionPremium";

export interface ConsumerSubscriptionsState {
  subscription: WholeSubscriptionStatus | null | undefined;
  status: "fulfilled" | "pending" | "rejected";
  plan: string;
}
const initialState: ConsumerSubscriptionsState = {
  subscription: undefined,
  status: "pending",
  plan: "--",
};

export const checkSubForUser = createAsyncThunk(
  "consumerSubscriptions/checkSub",
  async (tools: {
    keycloak: Keycloak.KeycloakInstance;
    axios: React.MutableRefObject<AxiosInstance | undefined>;
  }) => {
    const { axios } = tools;
    const res = await axios.current?.post("/subscription");

    return res?.data;
  },
);

export const checkSubscriptions = createAsyncThunk(
  "consumerSubscriptions/checkSubs",
  async (keycloak: Keycloak.KeycloakInstance) => {
    const res = await fetch(API_BASE_URL + "/subscription", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${keycloak?.token}`,
      },
      method: "POST",
      credentials: "include",
    });
    return res.json();
  },
);

export const mockCancelSubscriptionAsync = createAsyncThunk(
  "consumerSubscriptions/mockCancelSub",
  async (keycloak: Keycloak.KeycloakInstance) => {
    const kcToken = keycloak?.token ?? "";
    console.log("kc:" + kcToken);
    fetch(API_BASE_URL + "/subscription/mockSubscriptionExpiration", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${keycloak?.token}`,
      },
      method: "POST",
      // timeout: 10000,
    }).then(() => {
      // if (r?. === true) {
      keycloak
        .updateToken(999999999999999999999999999999999999999999999999)
        .then((r) => {
          if (r) {
            return parsePlanFromKeycloak(keycloak);
          }
        });
      return parsePlanFromKeycloak(keycloak);
      // }
    });
    return parsePlanFromKeycloak(keycloak);
  },
);

export const consumerSubscriptionsSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    updateSubscriptions: (state, action) => {
      state.status = "fulfilled";
      state.subscription = action.payload;
    },
    failedToCheckSubscriptions: (state) => {
      state.status = "rejected";
      state.subscription = null;
    },
    // appendSubscriptions: (state, action) => {
    //     state.status = 'fulfilled';
    //     if (Array.isArray(state.subscription)) {
    //         state.subscription = state.subscription.concat(action.payload);
    //     } else {
    //         state.subscription = [action.payload];
    //     }
    // },
    resetSubscriptionsState: (state) => {
      // state.subs = initialState.subs;
      // state.status = initialState.status;
      state = initialState;
    },
    updateCurrentPlan: (state, action) => {
      state.plan = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      // .addCase(updateSubscriptionAsync.pending, (state) => {
      //     state.status = 'pending';
      // })
      // .addCase(updateSubscriptionAsync.fulfilled, (state, action) => {
      //     state.status = 'fulfilled';
      //     // state.subs = action.payload;
      // })
      // .addCase(updateSubscriptionAsync.rejected, (state) => {
      //     state.status = 'rejected';
      // })
      .addCase(mockCancelSubscriptionAsync.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.plan = action.payload;
      })
      .addCase(checkSubForUser.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.subscription = action.payload;
      })
      .addCase(checkSubscriptions.rejected, (state) => {
        state.status = "rejected";
        state.subscription = null;
      })
      .addCase(checkSubscriptions.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.subscription = action.payload;
      });
  },
});

export const {
  updateSubscriptions,
  failedToCheckSubscriptions,
  resetSubscriptionsState,
  updateCurrentPlan,
} = consumerSubscriptionsSlice.actions;
export default consumerSubscriptionsSlice.reducer;
